import { render, staticRenderFns } from "./ChatRate.vue?vue&type=template&id=7f29c8fe&scoped=true"
import script from "./ChatRate.vue?vue&type=script&lang=js"
export * from "./ChatRate.vue?vue&type=script&lang=js"
import style0 from "./ChatRate.vue?vue&type=style&index=0&id=7f29c8fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f29c8fe",
  null
  
)

export default component.exports